<div class="component-commandPalette" *ngIf="isOpen">
    <div class="component-commandPalette-backdrop" (click)="onClickBackdrop()"></div>

    <div class="component-commandPalette-modal" role="dialog" aria-label="Příkazová paleta">
        <div class="component-commandPalette-header">
            <span class="fa fa-search component-commandPalette-icon" aria-hidden="true"></span>
            <input
                #searchInput
                type="text"
                class="component-commandPalette-input"
                placeholder="Hledat osoby, smlouvy, parcely…"
                [ngModel]="query"
                (ngModelChange)="onQueryChange($event)"
                autocomplete="off"
                spellcheck="false"
                aria-label="Vyhledat příkaz nebo entitu"/>
            <kbd class="component-commandPalette-kbd" title="Zavřít">Esc</kbd>
        </div>

        <div class="component-commandPalette-results">
            <ca-loading [loadState]="entityLoading" loadText="Probíhá hledání…">
                <div *ngIf="!entityLoading && flatResults.length === 0" class="component-commandPalette-empty">
                    <ng-container *ngIf="query.length === 0">Začněte psát pro vyhledávání…</ng-container>
                    <ng-container *ngIf="query.length > 0">Nic nenalezeno. Zkus jiné slovo.</ng-container>
                </div>

                <div *ngFor="let group of groupedResults; trackBy: trackByCategory"
                     class="component-commandPalette-group">
                    <div class="component-commandPalette-groupLabel">
                        {{ group.label }}
                        <span *ngIf="group.total > 0" class="component-commandPalette-groupCount">{{ group.total }}</span>
                    </div>
                    <ul class="component-commandPalette-list">
                        <li *ngFor="let item of group.items; trackBy: trackById; let i = index"
                            #itemElement
                            class="component-commandPalette-item"
                            [class.selected]="group.flatOffset + i === selectedIndex"
                            [class.actionRow]="item.rowKind"
                            (click)="onClickItem(item)"
                            (mouseenter)="onMouseEnterItem(group.flatOffset + i)">
                            <span *ngIf="item.icon" class="fa {{ item.icon }} component-commandPalette-itemIcon" aria-hidden="true"></span>

                            <!-- Osoba — stejné vykreslení jako landing-page-search (vč. stylu zaniklé osoby) -->
                            <span *ngIf="item.subject as subject" class="component-commandPalette-itemBody"
                                  [class.invalid]="subject.subjectValidity === 'invalid'"
                                  [attr.title]="(subject.subjectValidity === 'invalid') ? 'Zaniklá osoba nebo osoba dotčená změnou' : null">
                                <span class="component-commandPalette-itemTitle">
                                    {{ subject | displayName }}<ng-container *ngIf="subject.rodneCislo != null">, r.č. {{ subject.rodneCislo }}</ng-container><ng-container *ngIf="subject.ico != null">, ič {{ subject.ico }}</ng-container>
                                    <ca-subject-user-badge [subjects]="subject"></ca-subject-user-badge>
                                </span>
                                <span class="component-commandPalette-itemSubtitle">{{ subject | displayAddress : 'townFirst' }}</span>
                            </span>

                            <!-- Smlouva -->
                            <span *ngIf="item.contract as contract" class="component-commandPalette-itemBody">
                                <span class="component-commandPalette-itemTitle">
                                    Smlouva {{ contract.contractNumberOfficial ?? contract.contractNumber }}<ng-container *ngIf="contract.counterpartyNumber">, {{ contract.counterpartyNumber }}</ng-container>
                                </span>
                                <span *ngIf="contract.owners?.length" class="component-commandPalette-itemSubtitle">
                                    <ng-container *ngIf="contract.owners.length === 1">
                                        {{ contract.owners[0] | displayName }}<ng-container *ngIf="contract.owners[0].rodneCislo != null && contract.owners[0].opsubType !== 'SJM'">, r.č. {{ contract.owners[0].rodneCislo }}</ng-container><ng-container *ngIf="contract.owners[0].ico != null">, ič {{ contract.owners[0].ico }}</ng-container>
                                        <ca-subject-user-badge [subjects]="contract.owners[0]"></ca-subject-user-badge>
                                    </ng-container>
                                    <ca-contract-list-item-owners *ngIf="contract.owners.length > 1" [subjects]="contract.owners"></ca-contract-list-item-owners>
                                </span>
                                <span *ngIf="contract.tenants?.length" class="component-commandPalette-itemSubtitle">
                                    <ng-container *ngIf="contract.tenants.length === 1">
                                        {{ contract.tenants[0] | displayName }}<ng-container *ngIf="contract.tenants[0].rodneCislo != null && contract.tenants[0].opsubType !== 'SJM'">, r.č. {{ contract.tenants[0].rodneCislo }}</ng-container><ng-container *ngIf="contract.tenants[0].ico != null">, ič {{ contract.tenants[0].ico }}</ng-container>
                                        <ca-subject-user-badge [subjects]="contract.tenants[0]"></ca-subject-user-badge>
                                    </ng-container>
                                    <ng-container *ngIf="contract.tenants.length > 1">
                                        {{ contract.tenants | displayCountTenants }}
                                        <ca-subject-user-badge [subjects]="contract.tenants"></ca-subject-user-badge>
                                    </ng-container>
                                </span>
                            </span>

                            <!-- Parcela -->
                            <span *ngIf="item.parcel as parcel" class="component-commandPalette-itemBody">
                                <span class="component-commandPalette-itemTitle">
                                    číslo {{ parcel.parcis }}<span *ngIf="parcel.vymera">, <span [innerHtml]="parcel.vymera | displayAcreageString"></span></span>
                                </span>
                                <span class="component-commandPalette-itemSubtitle">
                                    <span *ngIf="parcel.katuzeNazev">k.ú. {{ parcel.katuzeNazev }}</span><span *ngIf="parcel.parType">, {{ parcel.parType }}</span>
                                </span>
                            </span>

                            <!-- Ostatní příkazy (Vytvořit, Admin, Nejčastější) — generický title/subtitle -->
                            <span *ngIf="!item.subject && !item.contract && !item.parcel" class="component-commandPalette-itemBody">
                                <span class="component-commandPalette-itemTitle">{{ item.title }}</span>
                                <span *ngIf="item.subtitle" class="component-commandPalette-itemSubtitle">{{ item.subtitle }}</span>
                            </span>
                        </li>
                    </ul>
                </div>
            </ca-loading>
        </div>

        <div class="component-commandPalette-footer">
            <span><kbd>↑</kbd><kbd>↓</kbd> navigovat</span>
            <span><kbd>↵</kbd> vybrat</span>
            <span><kbd>Esc</kbd> zavřít</span>
            <span class="component-commandPalette-footerHint"><kbd>/</kbd> nebo <kbd>Ctrl + k</kbd> otevřít odkudkoliv</span>
        </div>
    </div>
</div>